import { render, staticRenderFns } from "./SummaryProductItem.vue?vue&type=template&id=599c1ae1"
import script from "./SummaryProductItem.vue?vue&type=script&lang=js"
export * from "./SummaryProductItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports